import SavingThrowsDetails from './SavingThrowsDetails';

export default SavingThrowsDetails;
export { SavingThrowsDetails };
